import React, {useState, useEffect} from 'react'
import * as AuthActions from '../views/pages/authentication/login/store/actions';
import reducer from '../views/pages/authentication/login/store/reducers';
import withReducer from "../redux/withReducer.js";
import {history} from "../history"
import {useLocation} from "react-router-dom";
import Spinner from '../components/@vuexy/spinner/Loading-spinner';
import jwtService from '../services/jwtService';
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {toast} from "react-toastify";

function Auth({ children }) {

  const [waitAuthCheck, setWaitAuthCheck] = useState(true);
  const dispatch = useDispatch();
  const location = useLocation();
  const {t} = useTranslation();
  
  const auth = useSelector(({auth}) => {
    return auth ? auth.login : {};
  });

  useEffect(() => {
    Promise.all([
      jwtCheck()
    ]).then(() => {
      setWaitAuthCheck(false);
    })
  }, [])

  const jwtCheck = () => new Promise(resolve => {

    jwtService.on('onAutoLogin', () => {
      /**
       * Sign in and retrieve user data from Api
       */
      jwtService.signInWithToken()
        .then(user => {
          dispatch(AuthActions.setUserData(user))
          if (location.pathname === "/login") {
            if (user.path) {
              history.push(user.path);
            } else {
              history.push('/notfountinitialpage');
            }
          }
          resolve();
        })
        .catch(error => {
          //this.props.showMessage({message: error});

          resolve();
        })
    });

    jwtService.on('onAutoLogout', (message) => {
      dispatch(AuthActions.logout())
      jwtService.emit('goLoginPage');
      resolve();
    });

    jwtService.on('permissionDenied', (message) => {
      document.removeEventListener("permissionDenied", null, false);
      resolve();
    });

    jwtService.on('onNoAccessToken', () => {
      if (location.pathname.startsWith('/activate/') || location.pathname.startsWith('/forgotPassword')) {
        return resolve();
      }
      jwtService.emit('goLoginPage');
      resolve();
    });

    jwtService.on('goLoginPage', () => {
      history.push({
        pathname: '/login'
      });
    });

    jwtService.on('onLogoutFailed', () => {
      // TODO: Toaster show error
    });

    jwtService.on('changedUserInfo', () => {
      jwtService.emit('onAutoLogin');
    });

    jwtService.on('onIdleTimeout', () => {
      if (!auth.locked) {
        dispatch({
          type: AuthActions.LOCK_USER
        })
        if (location.pathname != "/lockscreen") {
          history.push('/lockscreen');
        }
      }
    });

    jwtService.on('serverUnreachable', () => {
      toast.error(t('general.errorcodes.server_unreachable'));
    });

    jwtService.init();

    return Promise.resolve();
  });

  return waitAuthCheck ? <Spinner/> : <React.Fragment children={children}/>;
}

export const AuthService = jwtService;

export default withReducer("auth", reducer)(Auth);

